import { ChargingStationMessageTab, MessageDetailSlideIn, MessagesPage, ProcessedMessageTab } from '@infuse/e-connector/message/pages';
import { InfusePageView } from '@infuse/ui/layouts';
import { AppRouter } from '@infuse/ui/router';
import { Plugin } from 'vue';
import { messagePermissions } from '@infuse/api/e-connector/message';

export const MessageFeaturePlugin: Plugin = {
  install() {
    AppRouter.addRoute('main', {
      path: '/messages',
      component: InfusePageView,
      meta: {
        name: 'nav.messages',
        icon: 'charging-sessions',
        group: 'nav.nav-group.activity',
        permissionIds: [messagePermissions.SEARCH]
      },
      children: [
        {
          path: '',
          name: 'messages',
          component: MessagesPage
        },
        {
          path: ':id',
          components: {
            default: MessagesPage,
            slideIn: MessageDetailSlideIn
          },
          children: [
            {
              path: '',
              redirect: {
                name: 'messages.charging-station-message'
              }
            },
            {
              path: 'charging-station-message',
              name: 'messages.charging-station-message',
              component: ChargingStationMessageTab,
              meta: {
                type: 'tab',
                label: 'tabs.messages.charging-station-message',
                permissionIds: [messagePermissions.GET]
              }
            },
            {
              path: 'processed-message',
              name: 'messages.processed-message',
              component: ProcessedMessageTab,
              meta: {
                type: 'tab',
                label: 'tabs.messages.processed-message',
                permissionIds: [messagePermissions.GET]
              }
            }
          ]
        }
      ]
    });
  }
};
